import config from '../../config';

export default {
  url: `${config.api.baseURL}/menus`,
  transformer(data) {
    return data;
  }
};
